/**
 * Ruta `/cuenta-inactiva` (US5, T049): destino de `fermin:worker-inactive` (`403 WORKER_INACTIVE`).
 *
 * No depende de `search` ni de parámetros: el puente de `__root.tsx` navega aquí sin nada más.
 */
import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { InactiveScreen } from '../features/access/inactive';

export function InactiveRoute() {
  const navigate = useNavigate();
  return <InactiveScreen onLoggedOut={() => void navigate({ to: '/', replace: true })} />;
}

export const Route = createFileRoute('/cuenta-inactiva')({
  component: InactiveRoute,
});
